// @flow
import { APICore } from './apiCore';
import config from '../../config';
import { buildQueryParams } from './search-shipments-kpis-request';

const api = new APICore();

const BASE_URL = config.SHIPMENTS_ANALYTICS_URL;

const makeApiCall = (endpoint: string, query: Query | string): Promise<any> => {
    if (typeof query === 'string') {
        return api.get(`${BASE_URL}${endpoint}?${query}`, {}, {});
    }
    const queryParams = buildQueryParams(query);
    return api.get(`${BASE_URL}${endpoint}`, queryParams, {});
};

function getShipmentsTotalCostByTimeframe(query): any {
    const endpoint = '/total_cost_by_timeframe';
    return makeApiCall(endpoint, query);
}

function getShipmentsBaselineCost(query): any {
    const endpoint = '/baseline_cost';
    return makeApiCall(endpoint, query);
}

function getShipmentsBaselineRatedCost(query): any {
    const endpoint = '/baseline_rated_cost';
    return makeApiCall(endpoint, query);
}

function getShipmentsBaselineCostCount(query): any {
    const endpoint = '/baseline_cost_count';
    return makeApiCall(endpoint, query);
}

function getShipmentsCostByCarrier(query): any {
    const endpoint = '/cost_by_carrier';
    return makeApiCall(endpoint, query);
}

function getShipmentsCostByTimeframe(query): any {
    const endpoint = '/cost_by_timeframe';
    return makeApiCall(endpoint, query);
}

function getShipmentsCostOverview(query): any {
    const endpoint = '/baseline_cost_details';
    return makeApiCall(endpoint, query);
}

export {
    getShipmentsTotalCostByTimeframe,
    getShipmentsBaselineCost,
    getShipmentsBaselineRatedCost,
    getShipmentsBaselineCostCount,
    getShipmentsCostByCarrier,
    getShipmentsCostByTimeframe,
    getShipmentsCostOverview,
};
